/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/RecommendedArticles/theme';

export const RecommendedArticlesTheme = theme;
